import { State } from 'src/types'
import { deepWeb } from './deepWeb'

export const webDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  deepWeb(ctx, state) // 普通・深めのウェブ
}
